const CARD_WIDTH = 336;
const RECT_HEIGHT = 136.5;
// Every deck is resized to a uniform 172px mobile height in the Figma
// mobile spec (rather than a flat scale factor), so width scales per-card
// to preserve its own aspect ratio.
const MOBILE_HEIGHT = 172;

// Small L-shaped crop-mark brackets in Primary/Blue 300, inset just inside
// each of the trapezoid's 4 visible corner vertices. One leg follows the
// (horizontal) top/bottom edge; the other leg is angled to match the
// trapezoid's slanted side, rather than a plain vertical line.
const CORNER_SIZE = 12;
const TRAPEZOID_INSET_RATIO = 0.08; // matches the clip-path's 8% / 92% inset
// Bracket's angled leg follows the same slant as the trapezoid's actual
// side, so it sits flush against the visible edge.
const BRACKET_SLANT_RATIO = TRAPEZOID_INSET_RATIO;
const CornerBracket = ({ x, y, corner, cardWidth, rectHeight }) => {
  const isRight = corner.includes('right');
  const isBottom = corner.includes('bottom');

  // Slant used for the bracket's angled leg - matches the trapezoid's own
  // slant (see BRACKET_SLANT_RATIO above).
  const sideDx = cardWidth * BRACKET_SLANT_RATIO * (isRight ? -1 : 1);
  const sideLength = Math.hypot(sideDx, rectHeight);
  const unitX = sideDx / sideLength;
  const unitY = rectHeight / sideLength;

  const horizontalLeg = { x: isRight ? -CORNER_SIZE : CORNER_SIZE, y: 0 };
  const angledLeg = {
    x: isBottom ? -unitX * CORNER_SIZE : unitX * CORNER_SIZE,
    y: isBottom ? -unitY * CORNER_SIZE : unitY * CORNER_SIZE,
  };

  const half = CORNER_SIZE + 2;
  return (
    <svg
      className="absolute"
      style={{ left: x - half, top: y - half, overflow: 'visible' }}
      width={half * 2}
      height={half * 2}
      viewBox={`${-half} ${-half} ${half * 2} ${half * 2}`}
    >
      <line x1={0} y1={0} x2={horizontalLeg.x} y2={horizontalLeg.y} stroke="#4659CA" strokeWidth="1.5" />
      <line x1={0} y1={0} x2={angledLeg.x} y2={angledLeg.y} stroke="#4659CA" strokeWidth="1.5" />
    </svg>
  );
};

const StatCard = ({ image, imageWidth, imageHeight, value, label, rectTop }) => {
  const cardHeight = rectTop + RECT_HEIGHT;
  const mobileScale = MOBILE_HEIGHT / cardHeight;
  const imageLeft = (CARD_WIDTH - imageWidth) / 2;

  return (
    <div
      className="shrink-0"
      style={{
        '--mw': `${CARD_WIDTH * mobileScale}px`,
        '--mh': `${MOBILE_HEIGHT}px`,
        '--dw': `${CARD_WIDTH}px`,
        '--dh': `${cardHeight}px`,
        '--mobile-scale': mobileScale,
      }}
    >
      <div className="relative w-[var(--mw)] h-[var(--mh)] sm:w-[var(--dw)] sm:h-[var(--dh)]">
        <div
          className="absolute top-0 left-0 origin-top-left scale-[var(--mobile-scale)] sm:scale-100"
          style={{ width: CARD_WIDTH, height: cardHeight }}
        >
          <img
            src={image}
            alt=""
            className="absolute top-0"
            style={{ left: imageLeft, width: imageWidth, height: imageHeight }}
          />

          {/* clip-path clips box-shadow too, so the shadow is applied via
              filter on this unclipped wrapper instead - it follows the
              trapezoid's actual visible silhouette. */}
          <div
            className="absolute"
            style={{
              left: 0,
              top: rectTop,
              width: CARD_WIDTH,
              height: RECT_HEIGHT,
              filter: 'drop-shadow(0px 8px 12px rgba(70,89,202,0.4))',
            }}
          >
            <div
              className="absolute inset-0 bg-[#E1E7F8]"
              style={{ clipPath: 'polygon(0 0, 100% 0, 92% 100%, 8% 100%)' }}
            />
          </div>

          <CornerBracket x={0} y={rectTop} corner="top-left" cardWidth={CARD_WIDTH} rectHeight={RECT_HEIGHT} />
          <CornerBracket x={CARD_WIDTH} y={rectTop} corner="top-right" cardWidth={CARD_WIDTH} rectHeight={RECT_HEIGHT} />
          <CornerBracket x={CARD_WIDTH * 0.08} y={rectTop + RECT_HEIGHT} corner="bottom-left" cardWidth={CARD_WIDTH} rectHeight={RECT_HEIGHT} />
          <CornerBracket x={CARD_WIDTH * 0.92} y={rectTop + RECT_HEIGHT} corner="bottom-right" cardWidth={CARD_WIDTH} rectHeight={RECT_HEIGHT} />

          <span
            className="absolute left-0 w-full text-center font-gilroy-bold text-[64px] leading-[72px] tracking-[0.04em] text-[#4659CA]"
            style={{ top: rectTop + 26 }}
          >
            {value}
          </span>
          <span
            className="absolute left-0 w-full text-center font-[Gilroy-Regular] text-[16px] leading-[22px] tracking-[0.02em] text-[#3C48B9]"
            style={{ top: rectTop + 102 }}
          >
            {label}
          </span>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
